import { PencilIcon } from 'lucide-react'
import { IconButton, SectionHeading } from '@rentflowdev/ui'

interface EditableSectionHeaderProps {
	title:     string
	editable:  boolean
	onToggle:  () => void
	editLabel: string
}

export function EditableSectionHeader({ title, editable, onToggle, editLabel }: EditableSectionHeaderProps) {
	return (
		<div className="flex items-center gap-4">
			<SectionHeading>{title}</SectionHeading>
			<IconButton
				type="button"
				variant={editable ? 'primary' : 'secondary'}
				size="sm"
				aria-label={editLabel}
				aria-pressed={editable}
				onClick={onToggle}
			>
				<PencilIcon className="size-3.5" />
			</IconButton>
		</div>
	)
}
